export default "__VITE_ASSET__34bd9bdc__"